import { useDeleteAlarm } from '@akin-home/alarms/react';
import { useDeleteAlert } from '@akin-home/alerts/frontend';
import { CalendarItemType } from '@akin-home/amplify';
import { useDeleteEvent } from '@akin-home/events/react';
import { useDeleteMeal } from '@akin-home/meals/react';
import { useCallback } from 'react';

/** A hook for exposing a combined delete hook for all type of calendar items */
export const useDeleteCalendarItem = () => {
  const deleteEvent = useDeleteEvent();
  const deleteAlarm = useDeleteAlarm();
  const deleteAlert = useDeleteAlert();
  const deleteMeal = useDeleteMeal();

  return useCallback(
    ({ id, type }: { id: string; type: CalendarItemType }) => {
      const param = { input: { id } };

      switch (type) {
        case 'Event':
          return deleteEvent.mutateAsync(param);
        case 'Alarm':
          return deleteAlarm.mutateAsync(param);
        case 'Alert':
          return deleteAlert.mutateAsync(param);
        case 'Meal':
          return deleteMeal.mutateAsync(param);
        default:
          return undefined;
      }
    },
    [deleteAlert, deleteEvent, deleteAlarm, deleteMeal]
  );
};
